import request from 'services/axios'

export const ManagementAddNewLoan = async (payload: IManagementBodyFirst) => {
    const { data }: { data: IManagementAddNewLoans } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/draft-installments/`,
        {
            amount: Number(payload.amount),
            interest_pay_mode: payload.interest_pay_mode,
            interest_rate: Number(payload.interest_rate),
            interest_type: payload.interest_type,
            fixed_interest_amount: payload.fixed_interest_amount,
            number_of_repayments: Number(payload.number_of_repayments),
            pay_date: payload.pay_date,
            due_date: payload.due_date,
            number_of_repaid_installments: 0,
            repayment_interval: 'mnt',
        }
    )
    return data
}

export const ManagementAddNewLoanValidate = async (
    payload: IManagementBodyValidate
) => {
    const { data } = await request.post(
        `/api/v1/moneypools/validate-draft-installments/`,
        {
            total_amount: Number(payload.amount),
            interest_pay_mode: payload.interest_pay_mode,
            interest_rate: Number(payload.interest_rate),
            interest_type: payload.interest_type,
            fixed_interest_amount: payload.fixed_interest_amount,
            installments: payload.installments,
        }
    )
    return data
}

export const ManagementAddNewLoanValidateJustAdd = async (
    payload: IManagementBodyAddJust
) => {
    const { data } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/loans/`,
        {
            number_of_repayments: Number(payload.number_of_repayments),
            repayment_interval: 'mnt',
            number_of_repaid_installments: 0,
            interest_rate: Number(payload.interest_rate),
            is_not_interest_rate: false,
            increase_amount: 0,
            interest_pay_mode: payload.interest_pay_mode,
            pay_date: payload.pay_date,
            due_date: payload.due_date,
            cashout: {
                poolship: Number(payload.poolShip),
                amount: Number(payload.amount),
                type: 'ctl',
                tag: payload.tag,
            },
            installment_data: payload.installments,
            loan_demand: payload?.loan_demand,
            guarantor_ids: payload.guarantor_ids ?? [],
        }
    )
    return data
}

export const ManagementAddNewLoanValidateFuckingAdd = async (
    payload: IManagementAddPayload
) => {
    const { data } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/loans/`,
        {
            number_of_repayments: Number(payload.number_of_repayments),
            repayment_interval: 'mnt',
            interest_rate: Number(payload.interest_rate),
            is_not_interest_rate: false,
            increase_amount: 0,
            interest_pay_mode: payload.interest_pay_mode,
            pay_date: payload.pay_date,
            due_date: payload.due_date,
            cashout: {
                poolship: Number(payload.poolShip),
                amount: Number(payload.amount),
                type: 'ctl',
                tag: payload.tag,
                transaction: {
                    bank_account: payload.bankAccount,
                    ctx_id: payload.ctx_id,
                    ctx_type: payload.ctx_type,
                    destination: payload.destination,
                    is_group_pay: false,
                    payer_name: '',
                    receiver: payload.receiver,
                    receiver_name: '',
                    source: 'hbb',
                    state: '',
                    state_time: '',
                    transaction_code: '',
                },
            },
            installment_data: payload.installments,
            loan_demand: payload?.loan_demand,
            guarantor_ids: payload.guarantor_ids ?? [],
        }
    )
    return data
}

export const ManagementAddNewLoanValidateAddOld = async (
    payload: IIManagementAddOldPayload
) => {
    const { data } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/loans/`,
        {
            number_of_repayments: Number(payload.number_of_repayments),
            repayment_interval: 'mnt',
            interest_rate: Number(payload.interest_rate),
            is_not_interest_rate: false,
            increase_amount: 0,
            interest_pay_mode: payload.interest_pay_mode,
            pay_date: payload.pay_date,
            due_date: payload.due_date,
            number_of_repaid_installments:
                payload.number_of_repaid_installments,
            cashout: {
                poolship: Number(payload.poolShip),
                amount: Number(payload.amount),
                type: 'ctl',
                tag: payload.tag,
            },
            installment_data: payload.installments,
            guarantor_ids: payload.guarantor_ids ?? [],
        }
    )
    return data
}
